import { render } from "./LegalTerms.vue?vue&type=template&id=7f2ca58f&scoped=true"
import script from "./LegalTerms.vue?vue&type=script&lang=js"
export * from "./LegalTerms.vue?vue&type=script&lang=js"

import "./LegalTerms.vue?vue&type=style&index=0&id=7f2ca58f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2ca58f"]])

export default __exports__